// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.terms[data-v-0d973334]{\n  min-height:100vh;\n  background:linear-gradient(180deg,hsla(0,0%,100%,0),#fff),linear-gradient(0deg,hsla(0,0%,92.2%,.5),hsla(0,0%,92.2%,.5)),#fff\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
